<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12 bg-dark-blue">
          <img src="/img/arrow-left-white.svg" class="mt-4" height="30" @click="$router.back()" />
          <h5 class="text-align-right white bold mt-3 mb-5">Confirme sua presença</h5>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center mt-5 mb-4">
          <img src="/img/selo-color.svg" height="70" @click="$router.replace('main')" />
        </div>



        <!-- Mensagem centralizada -->
        <div v-if="mensagem || mensagemErro" class="mensagem-centralizada">
          <h5 class="dark-blue-normal dark-blue-normal mb-5">{{ mensagem || mensagemErro }}</h5>
          <ValidationObserver ref="dados" v-if="!confirmado && !mensagemErro">
            <form>
              <div class="field mb-4">
                <ValidationProvider name="quantidade de acompanhantes" mode="passive" rules="required"
                  v-slot="{ errors, classes }">
                  <select class="select" :style="acompanhante && 'color: #0D4275;font-weight: 600;'"
                    v-model="acompanhante" @focus="clear" :class="classes">
                    <option :value="undefined">
                      Quantos acompanhantes?
                    </option>
                    <option v-for="item in acompanhantes" :key="item.label" :value="item.value">
                      {{ item.label }}
                    </option>
                  </select>
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </form>
          </ValidationObserver>
        </div>

        <div class="bottom">
          <button class="continue-btn" :disabled="loading || mensagemErro || confirmado" @click.prevent="handle">
            <span>CONFIRMAR</span>
          </button>
        </div>
      </div>

      <!-- Modal de erro -->
      <vue-bottom-sheet-vue2 ref="warning" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Não foi possivel enviar as informações</h5>
        </div>
      </vue-bottom-sheet-vue2>

    </div>
    <Loading v-if="loading" />
  </div>
</template>

<script>

import api from "../axiosConfig";
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";

export default {
  components: {
    VueBottomSheetVue2,
    Loading: () => import("./Loading.vue"),
  },
  data() {
    return {
      loading: false,
      idUsuario: undefined,
      regiaoId: undefined,
      mensagem: null, // Mensagem de sucesso ou confirmação
      mensagemErro: null, // Mensagem de erro
      confirmado: false,
      acompanhante: undefined,
      acompanhantes: [
        { label: "Nenhum", value: 0 },
        { label: "01 acompanhante", value: 1 },
        { label: "02 acompanhantes", value: 2 },
      ],
    };
  },
  created() {
    const idUsuario = window.sessionStorage.getItem("idUsuario");

    if (idUsuario === null || idUsuario === undefined || idUsuario === "undefined" || idUsuario === "") {
      this.$router.push("/login");
    } else {
      const parsedIdCliente = JSON.parse(idUsuario);
      this.idUsuario = parsedIdCliente;
    }

    this.fetchData(); // Chama a função para buscar os dados ao criar o componente
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    clear() {
      this.$nextTick(() => {
        this.$refs.dados.reset();
      });
    },
    async handle() {
      const valid = await this.$refs.dados.validate();
      if (!valid) return;

      await this.confirmarPresenca();
    },
    async confirmarPresenca() {
      try {
        this.loading = true;

        // Payload com os dados necessários para o backend
        const payload = {
          usuarioId: this.idUsuario,
          regiaoId: this.regiaoId, // Certifique-se de que `regiaoId` está definido no componente
          acompanhantes: this.acompanhante,
        };

        // Enviar a requisição POST para o endpoint do backend
        await api.post('/presencas', payload);

        // Exibir mensagem de sucesso
        this.mensagem = "Presença confirmada com sucesso ✅";
        this.mensagemErro = null; // Limpar mensagens de erro, se houver
        this.confirmado = true; // Limpar mensagens de erro, se houver
        setTimeout(() => {
          this.$router.replace("/sidebar"); // Redirecionar para a página principal
        }, 3000); // Limpar mensagem após 3 segundos

      } catch (error) {
        // Verificar se o erro contém uma mensagem do backend
        if (error.response && error.response.data && error.response.data.message) {
          this.mensagem = null;
          this.mensagemErro = error.response.data.message;
        } else {
          this.$refs.warning.open(); // Abre o modal de erro
        }
      } finally {
        this.loading = false;
      }
    },


    async fetchData() {
      try {
        this.loading = true;

        const response = await api.get(`/users/${this.idUsuario}/presenca`);
        const data = response.data;

        this.mensagem = data.mensagem;
        this.regiaoId = data.regiaoId;

      } catch (error) {
        // Verifica se o erro contém uma mensagem do backend
        if (error.response && error.response.data && error.response.data.message) {
          this.mensagemErro = error.response.data.message;
        } else {
          this.mensagemErro = "Ocorreu um erro inesperado. Tente novamente mais tarde.";
        }

      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.mensagem-centralizada {
  text-align: center;
  margin-top: 20px;
  padding: 30px;
  color: #0D4275;
  font-size: 15px;
  font-weight: bold;
}

.radio-group,
.checkbox-group {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
  align-items: flex-start;
}


.radio-option,
.checkbox-option {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #0D4275;
  cursor: pointer;
}

.custom-radio,
.custom-checkbox {
  width: 20px;
  height: 20px;
  border: 2px solid #2699FB;
  display: inline-block;
  position: relative;
}

.custom-radio {
  border-radius: 50%;
}

.radio-option input:checked+.custom-radio {
  background-color: #2699FB;
}

.radio-option input:checked+.custom-radio::after {
  content: "";
  width: 8px;
  height: 8px;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
</style>
